/* Soalune · comportamiento propio sobre Dawn: fechas de entrega, miniaturas de color, packs, talla obligatoria,
   guía de tallas en ventana, reels, cabecera transparente, «+ Añadir» de la venta cruzada, barra fija de compra
   y muestras de color en tarjetas. (La cuenta atrás se quitó del tema de zapatos NL el 02/11/2026.) */
(function () {
  'use strict';
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  /* Textos traducidos desde snippets/sl-scripts.liquid (window.SL_T); español si faltan. */
  var T = window.SL_T || {};
  var tx = function (k, porDefecto) { return T[k] || porDefecto; };

  /* Cuenta atrás hacia data-fin (ISO). Se oculta si no hay fecha o ya pasó; nunca se reinicia. */
  function cuentaAtras(el) {
    var fin = Date.parse(el.getAttribute('data-fin') || '');
    var reloj = el.querySelector('.sl-cuenta__reloj');
    if (!fin || !reloj) { el.hidden = true; return; }
    var dd = function (n) { return (n < 10 ? '0' : '') + n; };
    var t;
    var tick = function () {
      var s = Math.floor((fin - Date.now()) / 1000);
      if (s <= 0) { el.hidden = true; clearInterval(t); return; }
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
      reloj.innerHTML = (d ? '<span>' + d + '<small>' + tx('dias', 'días') + '</small></span>' : '') + '<span>' + dd(h) + '<small>h</small></span><span>' + dd(m) + '<small>min</small></span><span>' + dd(x) + '<small>s</small></span>';
      el.hidden = false;
    };
    t = setInterval(tick, 1000); tick();
  }

  /* Fechas de entrega a partir de los días hábiles de Ajustes del tema. */
  function plazo(el) {
    var a = window.SL_AJUSTES || {};
    if (!(a.plazoMin > 0 && a.plazoMax > 0)) return;
    var suma = function (n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
    var loc = T.locale || 'es-ES';
    var f = function (d) { return d.toLocaleDateString(loc, { weekday: 'short', day: 'numeric', month: 'short' }); };
    var plantilla = tx('llega', 'Llega entre el <b>[desde]</b> y el <b>[hasta]</b> ([min]-[max] días hábiles)');
    el.innerHTML = plantilla.replace('[desde]', f(suma(a.plazoMin))).replace('[hasta]', f(suma(a.plazoMax))).replace('[min]', a.plazoMin).replace('[max]', a.plazoMax);
  }

  /* Miniaturas de color: eligen el valor en el selector de Dawn y ocultan ese grupo. */
  function miniaturas(box) {
    var seccion = box.closest('section') || document;
    var opcion = box.getAttribute('data-opcion');
    var inputs = function () { return $$('variant-selects input[type="radio"], variant-selects select', seccion); };
    /* Dawn vuelve a pintar el selector al cambiar de variante (y perdía el display:none): se re-oculta con un observador. */
    var ocultar = function () {
      $$('variant-selects fieldset', seccion).forEach(function (fs) {
        var lg = fs.querySelector('legend');
        if (lg && lg.textContent.trim().indexOf(opcion) === 0) fs.style.display = 'none';
      });
    };
    ocultar();
    if (window.MutationObserver) new MutationObserver(ocultar).observe(seccion, { childList: true, subtree: true });
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.sl-mini'); if (!b) return;
      var v = b.getAttribute('data-valor');
      inputs().forEach(function (i) {
        if (i.tagName === 'INPUT' && i.value === v && i.name.indexOf(opcion) === 0) { i.checked = true; i.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      $$('.sl-mini', box).forEach(function (x) { x.classList.toggle('is-on', x === b); });
      var lbl = box.querySelector('[data-sl-valor]'); if (lbl) lbl.textContent = v;
    });
  }

  /* «+ Añadir» de la venta cruzada: añade a la cesta y refresca el cajón de Dawn. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sl-cruz]'); if (!b) return;
    var drawer = document.querySelector('cart-drawer');
    var secciones = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    b.disabled = true;
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-sl-cruz'), quantity: 1 }], sections: secciones, sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (r) {
      b.textContent = tx('anadido', 'Añadido'); b.classList.add('is-ok');
      if (drawer && r.sections) { r.id = r.items && r.items[0] && r.items[0].key; try { drawer.renderContents(r); } catch (err) { location.href = '/cart'; } }
    }).catch(function () { b.disabled = false; });
  });

  /* Muestras de color en tarjetas: cambian la foto sin salir de la colección (en táctil, el primer toque solo cambia la foto). */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('.sl-card .sl-sw[data-sl-img]'); if (!sw) return;
    var card = sw.closest('.sl-card'), img = card.querySelector('.sl-card__img .sl-media:not(.sl-alt) img');
    if (img) { img.removeAttribute('srcset'); img.src = sw.getAttribute('data-sl-img'); }
    $$('.sl-sw', card).forEach(function (x) { x.classList.toggle('is-on', x === sw); });
  });

  /* Barra fija: aparece cuando el botón principal de compra sale de la pantalla por arriba. */
  function barra(el) {
    var btn = document.querySelector('product-form button[name="add"]');
    if (!btn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { el.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(btn);
    el.querySelector('[data-sl-barra-add]').addEventListener('click', function () {
      if (btn.disabled) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      btn.click();
    });
  }


  /* Talla obligatoria: al entrar en la ficha no hay talla marcada (Dawn marca la primera) y no se puede
     añadir ni pagar hasta elegirla. En los looks hay dos selectores (talla del vestido y número): hacen
     falta los dos. Si el enlace trae ?variant= se respeta lo que trae. */
  var tallaElegida = true;
  var elegidos = {};
  /* Nombres de la opción de talla: Ajustes del tema → Soalune (sl_talla_opciones). */
  var nombresTalla = ((window.SL_AJUSTES && window.SL_AJUSTES.tallaNombres) || 'Maat,Talla,Size').split(',').map(function (x) { return x.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).filter(Boolean);
  var reTalla = new RegExp('^\\s*(' + nombresTalla.join('|') + '|n[úu]mero)', 'i');
  function marcarCuerpo() { document.body.classList.toggle('sl-sin-talla', !tallaElegida); }
  function setsTalla() {
    return $$('variant-selects fieldset').filter(function (f) {
      var l = f.querySelector('legend');
      return l && reTalla.test(l.textContent) && $$('input[type=radio]', f).length > 1;
    });
  }
  function claveSet(f) { return (f.querySelector('legend').textContent || '').trim().toLowerCase(); }
  function radiosTalla() {
    return setsTalla().reduce(function (a, f) { return a.concat($$('input[type=radio]', f)); }, []);
  }
  function pendientes() { return setsTalla().filter(function (f) { return !elegidos[claveSet(f)]; }); }
  function avisoTalla(mostrar) {
    $$('.sl-talla-aviso').forEach(function (p) { p.hidden = true; });
    if (!mostrar) return;
    var set = pendientes()[0];
    if (!set) return;
    var p = set.querySelector('.sl-talla-aviso');
    if (!p) {
      p = document.createElement('p');
      p.className = 'sl-talla-aviso';
      p.setAttribute('role', 'alert');
      p.style.cssText = 'margin:.6rem 0 0;color:#8a1c2b;font-size:1.35rem;font-weight:600';
      set.appendChild(p);
    }
    p.textContent = tx('kies_maat', 'Elige tu talla para continuar');
    p.hidden = false;
    set.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function tallaObligatoria() {
    if (tallaObligatoria.hecho) return;
    if (window.SL_AJUSTES && window.SL_AJUSTES.tallaObligatoria === false) return;
    var sets = setsTalla();
    if (!sets.length || /[?&]variant=/.test(location.search)) return;
    tallaObligatoria.hecho = true;
    tallaElegida = false;
    marcarCuerpo();
    radiosTalla().forEach(function (r) { r.checked = false; });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('variant-selects input[type=radio]')) return;
      var f = t.closest('fieldset');
      if (!f || setsTalla().indexOf(f) === -1) return;
      elegidos[claveSet(f)] = true;
      tallaElegida = pendientes().length === 0;
      marcarCuerpo();
      avisoTalla(false);
    }, true);
    /* Al cambiar una opción, Dawn vuelve a pintar el selector con valores marcados: se desmarcan los que
       la clienta aún no ha elegido. */
    var vs = document.querySelector('variant-selects');
    var raiz = vs && (vs.closest('section') || document.body);
    if (raiz && window.MutationObserver) {
      new MutationObserver(function () {
        if (tallaElegida) return;
        pendientes().forEach(function (f) {
          $$('input[type=radio]', f).forEach(function (r) { if (r.checked) r.checked = false; });
        });
      }).observe(raiz, { childList: true, subtree: true });
    }
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (tallaElegida || !f || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
      if (f.closest('.sl-cruzada, [data-sl-cruzada]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      avisoTalla(true);
    }, true);
    document.addEventListener('click', function (e) {
      if (tallaElegida) return;
      var b = e.target && e.target.closest && e.target.closest('.shopify-payment-button, shopify-buy-it-now-button, shopify-accelerated-checkout');
      if (!b) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      avisoTalla(true);
    }, true);
  }


  /* Packs tipo Curviva: las tarjetas eligen la opción de pack de Dawn (que se oculta) y activan un selector por funda. */
  function packs(box) {
    var seccion = box.closest('section') || document;
    var opcion = box.getAttribute('data-opcion'), eleccion = box.getAttribute('data-eleccion');
    var setDe = function (nombre) { return $$('variant-selects fieldset', seccion).filter(function (fs) { var lg = fs.querySelector('legend'); return lg && lg.textContent.trim().indexOf(nombre) === 0; })[0]; };
    var ocultar = function () { var fs = setDe(opcion); if (fs) fs.style.display = 'none'; };
    var primero = function () {
      var fs = setDe(eleccion), v = '';
      if (fs) { var c = fs.querySelector('input:checked'); if (c) v = c.value; }
      if (!v) { var m = document.querySelector('.sl-mini.is-on'); if (m) v = m.getAttribute('data-valor'); }
      var b = box.querySelector('[data-sl-pk-primero]'); if (!b) return;
      if (!tallaElegida) v = b.getAttribute('data-vacio') || '';
      if (v && b.textContent !== v) b.textContent = v;
    };
    var filas = function (n) {
      var f1 = box.querySelector('[data-sl-pk-fila-1]'); if (f1) f1.hidden = n < 2;
      $$('[data-sl-pk-fila]', box).forEach(function (f) {
        var on = +f.getAttribute('data-sl-pk-fila') <= n; f.hidden = !on;
        var sel = f.querySelector('select'); if (sel) sel.disabled = !on;
      });
    };
    ocultar(); primero();
    var act = box.querySelector('.sl-pack.is-on'); filas(act ? +act.getAttribute('data-n') : 1);
    if (window.MutationObserver) { var pend = false; new MutationObserver(function (muts) { if (pend) return; if (muts.every(function (m) { return box.contains(m.target); })) return; pend = true; requestAnimationFrame(function () { pend = false; ocultar(); primero(); }); }).observe(seccion, { childList: true, subtree: true }); }
    document.addEventListener('change', function () { setTimeout(primero, 50); });
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.sl-pack'); if (!b) return;
      var v = b.getAttribute('data-valor'), fs = setDe(opcion);
      if (fs) $$('input[type="radio"]', fs).forEach(function (i) { if (i.value === v) { i.checked = true; i.dispatchEvent(new Event('change', { bubbles: true })); } });
      $$('.sl-pack', box).forEach(function (x) { x.classList.toggle('is-on', x === b); });
      filas(+b.getAttribute('data-n'));
    });
  }

  /* Ventanas <dialog> (guía de tallas en cm). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sl-dialog]');
    if (a) { var d = document.getElementById(a.getAttribute('data-sl-dialog')); if (d && d.showModal) { e.preventDefault(); d.showModal(); } return; }
    if (e.target.closest && e.target.closest('[data-sl-dialog-cerrar]')) { var dc = e.target.closest('dialog'); if (dc) dc.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('sl-dialog')) e.target.close();
  });

  /* Reels: solo se reproducen los que están en pantalla (ahorra datos en móvil). */
  function reels(box) {
    var vids = $$('video', box);
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play && v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { var p = x.target.play(); if (p && p.catch) p.catch(function () {}); } else { x.target.pause(); } });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* Cabecera transparente sobre el hero de portada: mide su alto para que la foto suba por debajo. */
  function cabecera() {
    if (!document.body.classList.contains('sl-cab-trans')) return;
    var h = document.querySelector('.section-header');
    var medir = function () { if (h) document.documentElement.style.setProperty('--sl-cab-h', h.offsetHeight + 'px'); };
    medir(); window.addEventListener('resize', medir);
  }

  function iniciar() {
    $$('[data-sl-reels]').forEach(reels);
    cabecera();
    $$('[data-sl-cuenta]').forEach(cuentaAtras);
    $$('[data-sl-plazo]').forEach(plazo);
    $$('[data-sl-miniaturas]').forEach(miniaturas);
    tallaObligatoria();
    $$('[data-sl-packs]').forEach(packs);
    $$('[data-sl-barra]').forEach(barra);
  }

  /* Pack de 2 o más pares (04/11/2026): la talla de cada par extra es obligatoria. El <select required> no frenaba
     nada porque Dawn envía el formulario por fetch; se para aquí el clic (también el de la barra fija) antes del envío. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('product-form button[name="add"], .shopify-payment-button button'); if (!b) return;
    var falta = [].filter.call(document.querySelectorAll('.sl-packs__elegir select[required]'), function (s) {
      return !s.disabled && !s.value && !s.closest('[hidden]');
    })[0];
    if (!falta) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fila = falta.closest('.sl-packs__fila') || falta.parentNode;
    var p = fila.nextElementSibling;
    if (!p || !p.classList.contains('sl-talla-aviso')) {
      p = document.createElement('p'); p.className = 'sl-talla-aviso'; p.setAttribute('role', 'alert');
      p.style.cssText = 'margin:.2rem 0 .6rem;color:#8a1c2b;font-size:1.35rem;font-weight:600';
      fila.parentNode.insertBefore(p, fila.nextSibling);
    }
    p.textContent = tx('kies_maat_par', 'Elige también la talla del segundo par'); p.hidden = false;
    falta.focus(); falta.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('.sl-packs__elegir select'); if (!s || !s.value) return;
    var f = s.closest('.sl-packs__fila') || s.parentNode, p = f.nextElementSibling; if (p && p.classList.contains('sl-talla-aviso')) p.hidden = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
